import React from 'react';

function SortDropdown({ value, onChange }) {
    return (
        <select
            value={value}
            onChange={onChange}
            style={{
                padding: '8px 12px',
                fontSize: '16px',
                margin: '0 20px 20px',
                borderRadius: '6px',
                border: '1px solid #5E503F',
                backgroundColor: '#FAF3E0',
                color: '#5E503F',
                cursor: 'pointer'
            }}
        >
            <option value="recent">Most Recent</option>
            <option value="liked">Most Liked</option>
        </select>
    );
}

export default SortDropdown;